import { render } from "./ViewBuzz.vue?vue&type=template&id=df9a4d4c&scoped=true"
import script from "./ViewBuzz.vue?vue&type=script&lang=js"
export * from "./ViewBuzz.vue?vue&type=script&lang=js"

import "./view-buzz.scss?vue&type=style&index=0&id=df9a4d4c&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df9a4d4c"]])

export default __exports__